type Args = {
  /** The content row's current top in viewport coordinates. */
  parentTop: number;
  /** --ah-sticky-top: chrome fixed over the viewport, which never scrolls away. */
  stickyTop: number;
};

// Viewport-relative on purpose: deriving this from a document offset plus
// window.scrollY breaks wherever the scroller is not the window.
export const resolveRailOffset = ({ parentTop, stickyTop }: Args): number =>
  Math.max(stickyTop, Math.max(0, parentTop));
